<p-announcement key="Platform"></p-announcement>
@if (platformMode.bannerKey(); as modeKey) {
  <p-announcement-banner
    [variant]="platformMode.appliesToMe() ? 'warning' : 'info'"
    icon="lock"
    [closable]="false"
    [title]="'platform.mode.' + modeKey + '.title' | transloco"
    [message]="'platform.mode.' + modeKey + '.text' | transloco"
  ></p-announcement-banner>
}
<egi-navbar2 style="height: var(--topbar-height)" [hidden]="layoutQueries.isFullscreen$ | async"></egi-navbar2>

<mat-drawer-container style="flex: 1">
  <mat-drawer
    class="sidebar-drawer"
    style="width: var(--sidebar-width)"
    (openedChange)="layoutActions.toggleSideBar($event)"
    [opened]="layoutQueries.isSideBarOpen$ | async"
    >
    <egi-page-menu></egi-page-menu>
  </mat-drawer>
  <mat-drawer-content style="position: relative">
    <div style="height: 100%; display: flex; flex-direction: column">
      <div class="info-bar">
        <div class="breadcrumb-container">
          <egi-breadcrumb></egi-breadcrumb>
          <e-portal class="ml-2" eTextColor="separator" key="page-title"></e-portal>
        </div>
        <div class="portal-container"></div>
        <div class="info-bar-right">
          <e-portal key="info-bar-right" style="height: 100%"></e-portal>
          <button
            style="height: 100%; border-radius: 0 !important"
            eBtn
            squared
            straightCorners
            size="sm"
            (click)="layoutActions.toggleFullscreen()"
            color="primary-75"
            [icon]="(layoutQueries.isFullscreen$ | async) ? 'chevron-down' : 'chevron-up'"
          ></button>
        </div>
      </div>

      <div>
        <e-portal key="page-top"></e-portal>
      </div>
      <div style="position: relative">
        @if (layoutQueries.isLoading$ | async) {
          <e-progress-loader
            eBg="primary-25"
            color="elegant"
            style="height: 5px; z-index: 9999; position: absolute; left: 0; width: 100%"
          ></e-progress-loader>
        }
      </div>
      <div style="flex: 1; height: 100%; overflow: auto; display: flex">
        @if (appContext.activeNavigationItem?.isClickTroughPage) {
          <button
            eBtn
            style="align-self: stretch; background-color: var(--shell-subbar)"
            (click)="navigateToParent(appContext.activeNavigationItem)"
            straightCorners
            eTextColor="elegant"
            icon="chevron-left"
          ></button>
        }
        <div style="flex: 1">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </mat-drawer-content>
</mat-drawer-container>

<e-dialog
  size="responsive"
  title="Aanmelden"
  [open]="layoutQueries.showLoginDialog$ | async"
  (openChange)="layoutActions.closeLoginDialog()"
  >
  <ng-template>
    <login-factory
      showCredentialLogin
      (afterLogin)="onAfterLogin()"
    ></login-factory>
  </ng-template>
</e-dialog>

@if (supportAccess.canUse()) {
  <support-panel />
}
